import { BreadcrumbItem, Col, Row } from "reactstrap"

import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import React from "react"
import { getPrimaryTextClass } from "helpers/sf_utils"
import CopyUrl from "./CopyUrl"
import { bsh_isAdminUserDetailsPresent } from "helpers/sf_browser_storage_helper"

const Breadcrumb = props => {
  return (
    <Row>
      <Col xs="12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="text-capitalize text-black mb-0">
            {props.backOption && 
              <Link to={props.link}>
                <i className={`bx bx-arrow-back ${getPrimaryTextClass()} font-size-16 me-2 bx-sm`} />
              </Link>
            }
            {props.breadcrumbItem}
            {
              props?.copyUrl && bsh_isAdminUserDetailsPresent() && <CopyUrl />
            }
          </h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0 text-black">
              { props.title?
              <BreadcrumbItem>
                <Link to="#" className="text-black">{props.title}</Link>
              </BreadcrumbItem> : ''
              }
              { props.title?
              <BreadcrumbItem active>
                <Link to="#" className="text-black">{props.breadcrumbItem}</Link>
              </BreadcrumbItem> : ''
              }
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
  backOption: PropTypes.bool,
  link: PropTypes.string
}

export default Breadcrumb
